"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SafeUrl = exports.Safe = void 0;
const platform_browser_1 = require("@angular/platform-browser");
class Safe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(style) {
        return this.sanitizer.bypassSecurityTrustHtml(style);
    }
}
exports.Safe = Safe;
class SafeUrl {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(style) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(style);
    }
}
exports.SafeUrl = SafeUrl;
//# sourceMappingURL=safeHtml.pipe.js.map